"use strict";

var cov_140ivuud5n = function () {
  var path = "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\parallel-scripture\\ScriptureTable.js";
  var hash = "c51906f295ea8ac2dc695e863e272ecf552c984b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\parallel-scripture\\ScriptureTable.js",
    statementMap: {
      "0": {
        start: {
          line: 39,
          column: 18
        },
        end: {
          line: 39,
          column: 29
        }
      },
      "1": {
        start: {
          line: 40,
          column: 30
        },
        end: {
          line: 40,
          column: 51
        }
      },
      "2": {
        start: {
          line: 41,
          column: 42
        },
        end: {
          line: 41,
          column: 54
        }
      },
      "3": {
        start: {
          line: 42,
          column: 33
        },
        end: {
          line: 42,
          column: 45
        }
      },
      "4": {
        start: {
          line: 43,
          column: 18
        },
        end: {
          line: 43,
          column: 38
        }
      },
      "5": {
        start: {
          line: 44,
          column: 38
        },
        end: {
          line: 44,
          column: 50
        }
      },
      "6": {
        start: {
          line: 45,
          column: 56
        },
        end: {
          line: 45,
          column: 66
        }
      },
      "7": {
        start: {
          line: 47,
          column: 21
        },
        end: {
          line: 47,
          column: 23
        }
      },
      "8": {
        start: {
          line: 49,
          column: 2
        },
        end: {
          line: 59,
          column: 3
        }
      },
      "9": {
        start: {
          line: 56,
          column: 20
        },
        end: {
          line: 56,
          column: 56
        }
      },
      "10": {
        start: {
          line: 57,
          column: 18
        },
        end: {
          line: 57,
          column: 42
        }
      },
      "11": {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 58,
          column: 51
        }
      },
      "12": {
        start: {
          line: 61,
          column: 2
        },
        end: {
          line: 67,
          column: 15
        }
      },
      "13": {
        start: {
          line: 62,
          column: 21
        },
        end: {
          line: 65,
          column: 7
        }
      },
      "14": {
        start: {
          line: 62,
          column: 51
        },
        end: {
          line: 65,
          column: 5
        }
      },
      "15": {
        start: {
          line: 66,
          column: 4
        },
        end: {
          line: 66,
          column: 25
        }
      },
      "16": {
        start: {
          line: 69,
          column: 2
        },
        end: {
          line: 72,
          column: 14
        }
      },
      "17": {
        start: {
          line: 70,
          column: 26
        },
        end: {
          line: 70,
          column: 58
        }
      },
      "18": {
        start: {
          line: 71,
          column: 4
        },
        end: {
          line: 71,
          column: 35
        }
      },
      "19": {
        start: {
          line: 74,
          column: 18
        },
        end: {
          line: 110,
          column: 3
        }
      },
      "20": {
        start: {
          line: 84,
          column: 21
        },
        end: {
          line: 84,
          column: 44
        }
      },
      "21": {
        start: {
          line: 89,
          column: 26
        },
        end: {
          line: 89,
          column: 69
        }
      },
      "22": {
        start: {
          line: 108,
          column: 21
        },
        end: {
          line: 108,
          column: 39
        }
      },
      "23": {
        start: {
          line: 112,
          column: 22
        },
        end: {
          line: 112,
          column: 34
        }
      },
      "24": {
        start: {
          line: 114,
          column: 2
        },
        end: {
          line: 116,
          column: 3
        }
      },
      "25": {
        start: {
          line: 115,
          column: 4
        },
        end: {
          line: 115,
          column: 58
        }
      },
      "26": {
        start: {
          line: 118,
          column: 15
        },
        end: {
          line: 133,
          column: 82
        }
      },
      "27": {
        start: {
          line: 118,
          column: 29
        },
        end: {
          line: 133,
          column: 6
        }
      },
      "28": {
        start: {
          line: 119,
          column: 4
        },
        end: {
          line: 133,
          column: 6
        }
      },
      "29": {
        start: {
          line: 120,
          column: 21
        },
        end: {
          line: 120,
          column: 74
        }
      },
      "30": {
        start: {
          line: 122,
          column: 8
        },
        end: {
          line: 130,
          column: 10
        }
      },
      "31": {
        start: {
          line: 132,
          column: 6
        },
        end: {
          line: 132,
          column: 17
        }
      },
      "32": {
        start: {
          line: 135,
          column: 2
        },
        end: {
          line: 146,
          column: 26
        }
      },
      "33": {
        start: {
          line: 136,
          column: 30
        },
        end: {
          line: 136,
          column: 65
        }
      },
      "34": {
        start: {
          line: 138,
          column: 4
        },
        end: {
          line: 145,
          column: 5
        }
      },
      "35": {
        start: {
          line: 139,
          column: 22
        },
        end: {
          line: 139,
          column: 64
        }
      },
      "36": {
        start: {
          line: 141,
          column: 6
        },
        end: {
          line: 144,
          column: 7
        }
      },
      "37": {
        start: {
          line: 142,
          column: 8
        },
        end: {
          line: 142,
          column: 37
        }
      },
      "38": {
        start: {
          line: 143,
          column: 8
        },
        end: {
          line: 143,
          column: 57
        }
      },
      "39": {
        start: {
          line: 148,
          column: 2
        },
        end: {
          line: 167,
          column: 4
        }
      },
      "40": {
        start: {
          line: 170,
          column: 0
        },
        end: {
          line: 205,
          column: 2
        }
      },
      "41": {
        start: {
          line: 207,
          column: 18
        },
        end: {
          line: 215,
          column: 3
        }
      },
      "42": {
        start: {
          line: 207,
          column: 41
        },
        end: {
          line: 215,
          column: 1
        }
      }
    },
    fnMap: {
      "0": {
        name: "ScriptureTable",
        decl: {
          start: {
            line: 26,
            column: 9
          },
          end: {
            line: 26,
            column: 23
          }
        },
        loc: {
          start: {
            line: 38,
            column: 3
          },
          end: {
            line: 168,
            column: 1
          }
        },
        line: 38
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 61,
            column: 12
          },
          end: {
            line: 61,
            column: 13
          }
        },
        loc: {
          start: {
            line: 61,
            column: 18
          },
          end: {
            line: 67,
            column: 3
          }
        },
        line: 61
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 62,
            column: 32
          },
          end: {
            line: 62,
            column: 33
          }
        },
        loc: {
          start: {
            line: 62,
            column: 51
          },
          end: {
            line: 65,
            column: 5
          }
        },
        line: 62
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 69,
            column: 12
          },
          end: {
            line: 69,
            column: 13
          }
        },
        loc: {
          start: {
            line: 69,
            column: 18
          },
          end: {
            line: 72,
            column: 3
          }
        },
        line: 69
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 84,
            column: 15
          },
          end: {
            line: 84,
            column: 16
          }
        },
        loc: {
          start: {
            line: 84,
            column: 21
          },
          end: {
            line: 84,
            column: 44
          }
        },
        line: 84
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 89,
            column: 15
          },
          end: {
            line: 89,
            column: 16
          }
        },
        loc: {
          start: {
            line: 89,
            column: 26
          },
          end: {
            line: 89,
            column: 69
          }
        },
        line: 89
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 108,
            column: 15
          },
          end: {
            line: 108,
            column: 16
          }
        },
        loc: {
          start: {
            line: 108,
            column: 21
          },
          end: {
            line: 108,
            column: 39
          }
        },
        line: 108
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 118,
            column: 23
          },
          end: {
            line: 118,
            column: 24
          }
        },
        loc: {
          start: {
            line: 118,
            column: 29
          },
          end: {
            line: 133,
            column: 6
          }
        },
        line: 118
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 118,
            column: 29
          },
          end: {
            line: 118,
            column: 30
          }
        },
        loc: {
          start: {
            line: 119,
            column: 4
          },
          end: {
            line: 133,
            column: 6
          }
        },
        line: 119
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 119,
            column: 22
          },
          end: {
            line: 119,
            column: 23
          }
        },
        loc: {
          start: {
            line: 119,
            column: 39
          },
          end: {
            line: 133,
            column: 5
          }
        },
        line: 119
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 135,
            column: 12
          },
          end: {
            line: 135,
            column: 13
          }
        },
        loc: {
          start: {
            line: 135,
            column: 18
          },
          end: {
            line: 146,
            column: 3
          }
        },
        line: 135
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 207,
            column: 29
          },
          end: {
            line: 207,
            column: 30
          }
        },
        loc: {
          start: {
            line: 207,
            column: 41
          },
          end: {
            line: 215,
            column: 1
          }
        },
        line: 207
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 35,
            column: 2
          },
          end: {
            line: 35,
            column: 22
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 35,
            column: 20
          },
          end: {
            line: 35,
            column: 22
          }
        }],
        line: 35
      },
      "1": {
        loc: {
          start: {
            line: 36,
            column: 2
          },
          end: {
            line: 36,
            column: 13
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 36,
            column: 9
          },
          end: {
            line: 36,
            column: 13
          }
        }],
        line: 36
      },
      "2": {
        loc: {
          start: {
            line: 49,
            column: 2
          },
          end: {
            line: 59,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 49,
            column: 2
          },
          end: {
            line: 59,
            column: 3
          }
        }, {
          start: {
            line: 49,
            column: 2
          },
          end: {
            line: 59,
            column: 3
          }
        }],
        line: 49
      },
      "3": {
        loc: {
          start: {
            line: 50,
            column: 4
          },
          end: {
            line: 54,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 50,
            column: 4
          },
          end: {
            line: 50,
            column: 13
          }
        }, {
          start: {
            line: 51,
            column: 4
          },
          end: {
            line: 51,
            column: 19
          }
        }, {
          start: {
            line: 52,
            column: 4
          },
          end: {
            line: 52,
            column: 12
          }
        }, {
          start: {
            line: 53,
            column: 4
          },
          end: {
            line: 53,
            column: 21
          }
        }, {
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 54,
            column: 40
          }
        }],
        line: 50
      },
      "4": {
        loc: {
          start: {
            line: 58,
            column: 19
          },
          end: {
            line: 58,
            column: 50
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 58,
            column: 27
          },
          end: {
            line: 58,
            column: 45
          }
        }, {
          start: {
            line: 58,
            column: 48
          },
          end: {
            line: 58,
            column: 50
          }
        }],
        line: 58
      },
      "5": {
        loc: {
          start: {
            line: 76,
            column: 12
          },
          end: {
            line: 80,
            column: 7
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 77,
            column: 8
          },
          end: {
            line: 77,
            column: 39
          }
        }, {
          start: {
            line: 79,
            column: 8
          },
          end: {
            line: 79,
            column: 39
          }
        }],
        line: 76
      },
      "6": {
        loc: {
          start: {
            line: 81,
            column: 15
          },
          end: {
            line: 83,
            column: 44
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 82,
            column: 10
          },
          end: {
            line: 82,
            column: 43
          }
        }, {
          start: {
            line: 83,
            column: 10
          },
          end: {
            line: 83,
            column: 44
          }
        }],
        line: 81
      },
      "7": {
        loc: {
          start: {
            line: 84,
            column: 21
          },
          end: {
            line: 84,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 84,
            column: 21
          },
          end: {
            line: 84,
            column: 27
          }
        }, {
          start: {
            line: 84,
            column: 31
          },
          end: {
            line: 84,
            column: 44
          }
        }],
        line: 84
      },
      "8": {
        loc: {
          start: {
            line: 100,
            column: 12
          },
          end: {
            line: 104,
            column: 7
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 101,
            column: 8
          },
          end: {
            line: 101,
            column: 38
          }
        }, {
          start: {
            line: 103,
            column: 8
          },
          end: {
            line: 103,
            column: 36
          }
        }],
        line: 100
      },
      "9": {
        loc: {
          start: {
            line: 105,
            column: 15
          },
          end: {
            line: 107,
            column: 40
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 106,
            column: 10
          },
          end: {
            line: 106,
            column: 38
          }
        }, {
          start: {
            line: 107,
            column: 10
          },
          end: {
            line: 107,
            column: 40
          }
        }],
        line: 105
      },
      "10": {
        loc: {
          start: {
            line: 114,
            column: 2
          },
          end: {
            line: 116,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 114,
            column: 2
          },
          end: {
            line: 116,
            column: 3
          }
        }, {
          start: {
            line: 114,
            column: 2
          },
          end: {
            line: 116,
            column: 3
          }
        }],
        line: 114
      },
      "11": {
        loc: {
          start: {
            line: 114,
            column: 6
          },
          end: {
            line: 114,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 114,
            column: 6
          },
          end: {
            line: 114,
            column: 12
          }
        }, {
          start: {
            line: 114,
            column: 16
          },
          end: {
            line: 114,
            column: 33
          }
        }, {
          start: {
            line: 114,
            column: 37
          },
          end: {
            line: 114,
            column: 52
          }
        }],
        line: 114
      },
      "12": {
        loc: {
          start: {
            line: 123,
            column: 27
          },
          end: {
            line: 123,
            column: 63
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 123,
            column: 27
          },
          end: {
            line: 123,
            column: 31
          }
        }, {
          start: {
            line: 123,
            column: 35
          },
          end: {
            line: 123,
            column: 63
          }
        }],
        line: 123
      },
      "13": {
        loc: {
          start: {
            line: 138,
            column: 4
          },
          end: {
            line: 145,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 138,
            column: 4
          },
          end: {
            line: 145,
            column: 5
          }
        }, {
          start: {
            line: 138,
            column: 4
          },
          end: {
            line: 145,
            column: 5
          }
        }],
        line: 138
      },
      "14": {
        loc: {
          start: {
            line: 141,
            column: 6
          },
          end: {
            line: 144,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 141,
            column: 6
          },
          end: {
            line: 144,
            column: 7
          }
        }, {
          start: {
            line: 141,
            column: 6
          },
          end: {
            line: 144,
            column: 7
          }
        }],
        line: 141
      },
      "15": {
        loc: {
          start: {
            line: 159,
            column: 9
          },
          end: {
            line: 164,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 159,
            column: 9
          },
          end: {
            line: 159,
            column: 13
          }
        }, {
          start: {
            line: 160,
            column: 10
          },
          end: {
            line: 163,
            column: 18
          }
        }],
        line: 159
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0, 0],
      "3": [0, 0, 0, 0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "c51906f295ea8ac2dc695e863e272ecf552c984b"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _useDeepCompareEffect = _interopRequireDefault(require("use-deep-compare-effect"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/core/styles");

var _icons = require("@material-ui/icons");

var _core = require("@material-ui/core");

var _deepFreeze = _interopRequireDefault(require("deep-freeze"));

var _localStrings = require("../../core/localStrings");

var _ = require("..");

var _Selections = require("../selections/Selections.context");

var _helpers = require("./helpers");

function ScriptureTable(_ref) {
  var title = _ref.title,
      titles = _ref.titles,
      books = _ref.books,
      height = _ref.height,
      reference = _ref.reference,
      quote = _ref.quote,
      occurrence = _ref.occurrence,
      buttons = _ref.buttons,
      _ref$renderOffscreen = _ref.renderOffscreen,
      renderOffscreen = _ref$renderOffscreen === void 0 ? (cov_140ivuud5n.b[0][0]++, {}) : _ref$renderOffscreen,
      _ref$open = _ref.open,
      open = _ref$open === void 0 ? (cov_140ivuud5n.b[1][0]++, true) : _ref$open,
      onOpen = _ref.onOpen;
  cov_140ivuud5n.f[0]++;
  var classes = (cov_140ivuud5n.s[0]++, useStyles());

  var _ref2 = (cov_140ivuud5n.s[1]++, (0, _react.useState)(!!reference)),
      _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
      filter = _ref3[0],
      setFilter = _ref3[1];

  var _ref4 = (cov_140ivuud5n.s[2]++, (0, _react.useState)([])),
      _ref5 = (0, _slicedToArray2.default)(_ref4, 2),
      referenceIds = _ref5[0],
      setReferenceIds = _ref5[1];

  var _ref6 = (cov_140ivuud5n.s[3]++, (0, _react.useState)([])),
      _ref7 = (0, _slicedToArray2.default)(_ref6, 2),
      _columns = _ref7[0],
      setColumns = _ref7[1];

  var columns = (cov_140ivuud5n.s[4]++, (0, _deepFreeze.default)(_columns));

  var _ref8 = (cov_140ivuud5n.s[5]++, (0, _react.useState)([])),
      _ref9 = (0, _slicedToArray2.default)(_ref8, 2),
      selections = _ref9[0],
      setSelections = _ref9[1];

  var _ref10 = (cov_140ivuud5n.s[6]++, (0, _react.useState)()),
      _ref11 = (0, _slicedToArray2.default)(_ref10, 2),
      columnsMenuAnchorEl = _ref11[0],
      setColumnsMenuAnchorEl = _ref11[1];

  var verseObjects = (cov_140ivuud5n.s[7]++, []);
  cov_140ivuud5n.s[8]++;

  if ((cov_140ivuud5n.b[3][0]++, reference) && (cov_140ivuud5n.b[3][1]++, reference.verse) && (cov_140ivuud5n.b[3][2]++, books[0]) && (cov_140ivuud5n.b[3][3]++, books[0].chapters) && (cov_140ivuud5n.b[3][4]++, books[0].chapters[reference.chapter])) {
    cov_140ivuud5n.b[2][0]++;
    var chapter = (cov_140ivuud5n.s[9]++, books[0].chapters[reference.chapter]);
    var verse = (cov_140ivuud5n.s[10]++, chapter[reference.verse]);
    cov_140ivuud5n.s[11]++;
    verseObjects = verse ? (cov_140ivuud5n.b[4][0]++, verse.verseObjects) : (cov_140ivuud5n.b[4][1]++, []);
  } else {
    cov_140ivuud5n.b[2][1]++;
  }

  cov_140ivuud5n.s[12]++;
  (0, _useDeepCompareEffect.default)(function () {
    cov_140ivuud5n.f[1]++;

    var _columns = (cov_140ivuud5n.s[13]++, titles.map(function (title, index) {
      cov_140ivuud5n.f[2]++;
      cov_140ivuud5n.s[14]++;
      return {
        id: index,
        label: title
      };
    }));

    cov_140ivuud5n.s[15]++;
    setColumns(_columns);
  }, [titles]);
  cov_140ivuud5n.s[16]++;
  (0, _useDeepCompareEffect.default)(function () {
    cov_140ivuud5n.f[3]++;

    var _referenceIds = (cov_140ivuud5n.s[17]++, (0, _helpers.referenceIdsFromBooks)({
      books: books
    }));

    cov_140ivuud5n.s[18]++;
    setReferenceIds(_referenceIds);
  }, [books]);
  var actions = (cov_140ivuud5n.s[19]++, [{
    icon: open ? (cov_140ivuud5n.b[5][0]++, _react.default.createElement(_icons.UnfoldLess, {
      fontSize: "small"
    })) : (cov_140ivuud5n.b[5][1]++, _react.default.createElement(_icons.UnfoldMore, {
      fontSize: "small"
    })),
    tooltip: open ? (cov_140ivuud5n.b[6][0]++, (0, _localStrings.localString)('CloseScripturePane')) : (cov_140ivuud5n.b[6][1]++, (0, _localStrings.localString)('ExpandScripturePane')),
    onClick: function onClick() {
      cov_140ivuud5n.f[4]++;
      cov_140ivuud5n.s[20]++;
      return (cov_140ivuud5n.b[7][0]++, onOpen) && (cov_140ivuud5n.b[7][1]++, onOpen(!open));
    }
  }, {
    icon: _react.default.createElement(_icons.ViewColumn, {
      fontSize: "small"
    }),
    tooltip: (0, _localStrings.localString)('ManageVersions'),
    onClick: function onClick(event) {
      cov_140ivuud5n.f[5]++;
      cov_140ivuud5n.s[21]++;
      return setColumnsMenuAnchorEl(event.currentTarget);
    },
    menu: _react.default.createElement(_.ColumnsMenu, {
      columns: columns,
      onColumns: setColumns,
      anchorEl: columnsMenuAnchorEl,
      onAnchorEl: setColumnsMenuAnchorEl
    })
  }, {
    icon: filter ? (cov_140ivuud5n.b[8][0]++, _react.default.createElement(_icons.ShortText, {
      fontSize: "small"
    })) : (cov_140ivuud5n.b[8][1]++, _react.default.createElement(_icons.Subject, {
      fontSize: "small"
    })),
    tooltip: filter ? (cov_140ivuud5n.b[9][0]++, (0, _localStrings.localString)('ExpandChapter')) : (cov_140ivuud5n.b[9][1]++, (0, _localStrings.localString)('CollapseChapter')),
    onClick: function onClick() {
      cov_140ivuud5n.f[6]++;
      cov_140ivuud5n.s[22]++;
      return setFilter(!filter);
    }
  }]);

  var _referenceIds = (cov_140ivuud5n.s[23]++, referenceIds);

  cov_140ivuud5n.s[24]++;

  if ((cov_140ivuud5n.b[11][0]++, filter) && (cov_140ivuud5n.b[11][1]++, reference.chapter) && (cov_140ivuud5n.b[11][2]++, reference.verse)) {
    cov_140ivuud5n.b[10][0]++;
    cov_140ivuud5n.s[25]++;
    _referenceIds = [(0, _helpers.referenceIdFromReference)(reference)];
  } else {
    cov_140ivuud5n.b[10][1]++;
  }

  var rows = (cov_140ivuud5n.s[26]++, (0, _react.useMemo)(function () {
    cov_140ivuud5n.f[7]++;
    cov_140ivuud5n.s[27]++;
    return function () {
      cov_140ivuud5n.f[8]++;
      cov_140ivuud5n.s[28]++;
      return _referenceIds.map(function (referenceId) {
        cov_140ivuud5n.f[9]++;
        var verses = (cov_140ivuud5n.s[29]++, (0, _helpers.versesFromReferenceIdAndBooks)({
          referenceId: referenceId,
          books: books
        }));
        var row = (cov_140ivuud5n.s[30]++, _react.default.createElement(_.Row, {
          renderOffscreen: (cov_140ivuud5n.b[12][0]++, open) && (cov_140ivuud5n.b[12][1]++, renderOffscreen[referenceId]),
          key: referenceId,
          verses: verses,
          referenceId: referenceId,
          reference: reference,
          filter: filter,
          columns: columns
        }));
        cov_140ivuud5n.s[31]++;
        return row;
      });
    };
  }, [_referenceIds, books, open, renderOffscreen, reference, filter, columns]));
  cov_140ivuud5n.s[32]++;
  (0, _useDeepCompareEffect.default)(function () {
    cov_140ivuud5n.f[10]++;
    var scrollReferenceId = (cov_140ivuud5n.s[33]++, (0, _helpers.referenceIdFromReference)(reference));
    cov_140ivuud5n.s[34]++;

    if (!filter) {
      cov_140ivuud5n.b[13][0]++;
      var element = (cov_140ivuud5n.s[35]++, document.getElementById(scrollReferenceId));
      cov_140ivuud5n.s[36]++;

      if (element) {
        cov_140ivuud5n.b[14][0]++;
        cov_140ivuud5n.s[37]++;
        element.scrollIntoView(true);
        cov_140ivuud5n.s[38]++;
        document.getElementById('wrapY').scrollTop -= 30;
      } else {
        cov_140ivuud5n.b[14][1]++;
      }
    } else {
      cov_140ivuud5n.b[13][1]++;
    }
  }, [filter, reference]);
  cov_140ivuud5n.s[39]++;
  return _react.default.createElement(_Selections.SelectionsContextProvider, {
    quote: quote // onQuote={onQuote} // disable until round trip is working
    ,
    occurrence: occurrence,
    verseObjects: verseObjects,
    selections: selections,
    onSelections: setSelections
  }, _react.default.createElement(_.Toolbar, {
    title: title,
    actions: actions,
    buttons: buttons
  }), _react.default.createElement("div", {
    id: "wrapY",
    className: classes.wrapY,
    style: {
      maxHeight: height
    }
  }, (cov_140ivuud5n.b[15][0]++, open) && (cov_140ivuud5n.b[15][1]++, _react.default.createElement(_core.Table, {
    className: classes.table
  }, _react.default.createElement(_.Headers, {
    columns: columns
  }), _react.default.createElement(_core.TableBody, {
    className: classes.tableBody
  }, rows())))));
}

cov_140ivuud5n.s[40]++;
ScriptureTable.propTypes = {
  titles: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]).isRequired).isRequired,
  books: _propTypes.default.arrayOf(_propTypes.default.shape({
    headers: _propTypes.default.array.isRequired,
    chapters: _propTypes.default.object.isRequired
  })).isRequired,

  /** the reference to scroll into view */
  reference: _propTypes.default.shape({
    bookId: _propTypes.default.string,
    chapter: _propTypes.default.number,
    verse: _propTypes.default.number
  }),

  /** bypass rendering only when visible */
  renderOffscreen: _propTypes.default.object,

  /** render unsupported usfm markers */
  showUnsupported: _propTypes.default.bool,

  /** override text direction detection */
  direction: _propTypes.default.string,

  /** disable popovers for aligned and original language words */
  disableWordPopover: _propTypes.default.bool,

  /** filter the view to the reference */
  filter: _propTypes.default.bool,

  /** pass the quote in from parent state */
  quote: _propTypes.default.string,

  /** callback to return the quote when selections made */
  onQuote: _propTypes.default.func,

  /** set the default open state */
  open: _propTypes.default.string,

  /** callback to update open state */
  onOpen: _propTypes.default.func
};
var useStyles = (cov_140ivuud5n.s[41]++, (0, _styles.makeStyles)(function (theme) {
  cov_140ivuud5n.f[11]++;
  cov_140ivuud5n.s[42]++;
  return {
    root: {},
    wrapY: {
      overflowY: 'auto',
      overflowX: 'auto'
    },
    table: {},
    tableBody: {}
  };
}));
var _default = ScriptureTable;
exports.default = _default;